angular.module('bmsApp.merrymaids.cis').factory('MMCisSvc', function (CRUDSvc) {

    var self = {
        getWeekData: function (params) {
            return CRUDSvc.get('api/merrymaids/cis/getWeekData', params);
        },
        save: function (params) {
            return CRUDSvc.post('api/merrymaids/cis/save', params);
        },
        update: function (params) {
            return CRUDSvc.update('api/merrymaids/cis/update', params);
        },
        check: function (params) {
            return CRUDSvc.get('api/merrymaids/cis/check', params);
        },
        read: function (params) {
            return CRUDSvc.get('api/merrymaids/cis/read', params);
        }
    };
    return self;

});
